import { Flex, Text } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ExtensionBadge } from '~/components/shared/ExtensionBadge'
import { ReferButton } from '~/pages/WebPhone/ReferButton'
import { Size } from '~/types/ThemeTypes'

import { useTransferTargetStyle } from './componentStyles/TransferTarget.style'
import { normalizeWhitespace } from './utils/stringUtils'

interface TransferTargetProps {
  id: string | number
  number: string
  name: string
  onTransfer: (target: string) => void
}
export const TransferTarget = ({
  id,
  number,
  name,
  onTransfer,
}: TransferTargetProps) => {
  const { t } = useTranslation()
  const handleButtonClick = () => {
    onTransfer(number)
  }

  const styles = useTransferTargetStyle()

  // Extract layout properties to apply as native props (Chakra v3 requirement)
  const containerProps = {
    justifyContent: styles.container?.justifyContent,
    alignItems: styles.container?.alignItems,
  }

  const labelProps = {
    display: styles.label?.display,
    flexDirection: styles.label?.flexDirection,
    justifyContent: styles.label?.justifyContent,
  }

  return (
    <Flex key={id} css={styles.container} {...containerProps}>
      <Flex css={styles.label} {...labelProps}>
        <ExtensionBadge size={Size.lg} extension={number} />
        <Text css={styles.name} lineClamp={1}>
          {name}
        </Text>
      </Flex>
      <ReferButton
        buttonText={t('transferTarget.buttonText')}
        ariaLabel={t('transferTarget.buttonAriaLabel', {
          name: normalizeWhitespace(name),
          number: normalizeWhitespace(number),
        })}
        onClick={handleButtonClick}
        buttonStyles={styles.button}
        textStyles={styles.buttonText}
      />
    </Flex>
  )
}
